import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  leadIcon: css`
    height: ${spacing(5)};
  `,
  trailIcon: css`
    height: ${spacing(3)};
  `,
}
